module.exports = __webpack_public_path__ + "img/hinh-xam-nho-mini-dep-15.jpg";